import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "@/config";

const BUILDS = [
  {
    id: "local-service",
    title: "The Local Service Build",
    industry: "Home & Local Services",
    challenge: "Leads scattered across DMs, voicemail, and a website that never converts — with no follow-up after hours.",
    solution: "Conversion website + CRM + AI lead response + automated SMS/email follow-up + paid search.",
    services: ["Web", "CRM", "AI", "Paid Ads"],
  },
  {
    id: "authority-engine",
    title: "The Authority Engine",
    industry: "Consultants & Professional Services",
    challenge: "Strong expertise, inconsistent pipeline. Referrals carry the business and content goes nowhere.",
    solution: "Offer positioning + content system + lead funnel + booking workflow + nurture automation.",
    services: ["Strategy", "Content", "Funnels", "Automation"],
  },
  {
    id: "mission-growth",
    title: "The Mission Growth System",
    industry: "Nonprofits & Ministries",
    challenge: "A mission worth supporting, but donor and member journeys end at a single visit.",
    solution: "Story-driven creative + landing system + CRM + lifecycle communication and follow-up.",
    services: ["Creative", "Web", "CRM", "Email/SMS"],
  },
];

export default function Work() {
  return (
    <section id="work" data-testid="work-section" className="relative overflow-hidden border-t border-line px-6 py-28 md:px-12 md:py-40">
      <div className="absolute inset-0">
        <img src={IMAGES.stairs} alt="" aria-hidden="true" className="h-full w-full object-cover opacity-15 grayscale" />
        <div className="absolute inset-0 bg-black/80" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1600px]">
        <Reveal><Overline>08 — Selected Work</Overline></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white md:text-5xl lg:text-6xl">
            Built around <span className="text-zinc-500">outcomes</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-2xl text-sm leading-relaxed text-zinc-500">
            Full client case studies with verified metrics are in preparation — we don&rsquo;t
            publish numbers we can&rsquo;t stand behind. Until then, these are the growth
            systems we build.
          </p>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 gap-px bg-white/10 lg:grid-cols-3">
          {BUILDS.map((b, i) => (
            <Reveal key={b.id} delay={i * 0.1} className="h-full">
              <article
                data-testid={`work-card-${b.id}`}
                className="group flex h-full flex-col bg-black/60 p-10 backdrop-blur-sm transition-colors duration-500 hover:bg-black/40"
              >
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-crimson">{b.industry}</p>
                <h3 className="mt-4 font-display text-2xl font-extrabold uppercase tracking-tight text-white">{b.title}</h3>
                <div className="mt-8 space-y-6 text-sm leading-relaxed">
                  <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Challenge</p>
                    <p className="mt-2 text-zinc-400">{b.challenge}</p>
                  </div>
                  <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Solution</p>
                    <p className="mt-2 text-zinc-300">{b.solution}</p>
                  </div>
                </div>
                <div className="mt-auto flex flex-wrap gap-2 pt-10">
                  {b.services.map((s) => (
                    <span key={s} className="border border-white/15 px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-zinc-400">{s}</span>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
